module.exports = "/_next/static/images/b86e134144393077de2c660cc8ded7ba-app-screenshots-xs@2x.jpg.webp";